import React, { useState } from 'react';
import { Form } from 'antd';
import { useModal } from '../../../contexts/modalsContext/modalsContext';
import {
  sendPasswordRecoveryService,
} from '../../../../services/login/Login.api';
import formSetDynamicErrors from '../../../../utils/functions/formSetDynamicErrors';
import SendPasswordRecoveryForm from '../../forms/passwordRecovery/SendPasswordRecoveryForm';
import PasswordRecoveryDrawer from '../drawers/passwordRecoveryDrawer/PasswordRecoveryDrawer';
import PasswordRecoveryModal from '../modals/passwordRecoveryModal/PasswordRecoveryModal';
import useTranslation from '../../../hooks/translation/useTranslation';

function PasswordRecovery() {
  const { trans, currentLanguage } = useTranslation();
  const [activeStep, setActiveStep] = useState(1);
  const {
    showPasswordRecovery,
    setShowPasswordRecovery,
  } = useModal();
  const [sendRecoveryForm] = Form.useForm();

  const handleSendRecoverySubmit = async (values) => {
    try {
      const res = await sendPasswordRecoveryService(values, currentLanguage);
      if (res.status === 'success') {
        sendRecoveryForm.resetFields();
        setActiveStep(2);
      }
    } catch (e) {
      formSetDynamicErrors({
        e,
        form: sendRecoveryForm,
      });
    }
  };

  const handleClose = () => {
    setShowPasswordRecovery(false);
    sendRecoveryForm.resetFields();
    setActiveStep(1);
  };

  const items = [
    {
      key: 1,
      children: <SendPasswordRecoveryForm
        handleSubmit={handleSendRecoverySubmit}
        form={sendRecoveryForm}
      />,
    }, {
      key: 2,
      children:
  <h2 className="m-0 font-big-bold text-center">
    {trans('please_check_your_email')}
  </h2>,
    },
  ];

  return (
    <>
      <PasswordRecoveryDrawer
        items={items}
        activeStep={activeStep}
        show={showPasswordRecovery}
        handleClose={handleClose}
      />
      <PasswordRecoveryModal
        items={items}
        activeStep={activeStep}
        show={showPasswordRecovery}
        handleClose={handleClose}
      />
    </>
  );
}

export default PasswordRecovery;
